<template>
  <div id="sources">
    <div class="row">
      <div class="col-md-12">
        <h6 style="border-bottom: 1px #ccc solid; padding: 5px 0px">
          Akun Terhubung
        </h6>
        <table class="table">
          <thead>
            <tr>
              <th width="10%">Channel</th>
              <th>Akun</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(acc, index) in project_detail.socmed_creds"
              :key="index"
            >
              <td><i :class="getIcon(index)"></i></td>
              <td>
                {{
                  index == "facebook"
                    ? project_detail.socmed_creds[index].account_name
                    : project_detail.socmed_creds[index].screen_name
                }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="col-md-12">
        <h6 style="border-bottom: 1px #ccc solid; padding: 10px 0px">
          Daftar Halaman Facebook
          <button
            class="pull-right btn btn-sm btn-success btn-icon-left"
            @click="addHalaman"
          >
            <i class="bi bi-plus"></i> <span>Tambah Halaman</span>
          </button>
        </h6>
        <table class="table" id="table_fp">
          <thead>
            <tr>
              <th width="5%">No</th>
              <th>Nama Halaman</th>
              <th width="5%">Aksi</th>
            </tr>
          </thead>
          <tbody></tbody>
        </table>
      </div>

      <div class="col-md-12">
        <h6 style="border-bottom: 1px #ccc solid; padding: 10px 0px">
          Daftar Hashtag Crawling Instagram
          <button
            class="pull-right btn btn-sm btn-success btn-icon-left"
            @click="addHashtagIG"
          >
            <i class="bi bi-plus"></i> <span>Tambah Hashtag</span>
          </button>
        </h6>
        <table class="table" id="table_hi">
          <thead>
            <tr>
              <th width="5%">No</th>
              <th>Hashtag</th>
              <th width="5%">Aksi</th>
            </tr>
          </thead>
          <tbody></tbody>
        </table>
      </div>
    </div>
    <modal-dynamic-component
      v-if="modal"
      :key="modal_key"
      :modal="modal"
      :data="modal_data"
    />
  </div>
</template>

<script>
import $ from "jquery";
import modal_dynamic from "@/views/components/modal_dynamic.vue";
import modal_add_facebook_fanpage from "@/views/components/super-admin/detail-project/modal_add_facebook_fanpage.vue";
import modal_add_hashtag from "@/views/components/super-admin/detail-project/modal_add_hashtag.vue";
import facebook_page from "@/views/components/settings/keyword/facebook_page.vue";
import swal from "sweetalert";

export default {
  name: "tab_sources",
  components: {
    "modal-dynamic-component": modal_dynamic,
  },
  props: {
    data: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {
      modal: null,
      modal_key: 0,
      modal_data: [],
      table_hashtag: null,
      table_fb: null,
      data_hashtag: null,
      data_fb: null,
      id_project: parseInt(atob(this.$route.query.ref)),
      project_detail: this.data[0],
    };
  },
  methods: {
    addHalaman: function () {
      this.modal = {};
      this.modal.title = "Tambah Halaman Facebook";
      this.modal.subtitle =
        "Silahkan masukan nama halaman facebook kemudian tekan tombol cari";
      this.modal.component = modal_add_facebook_fanpage;
      this.modal_data[0] = this.project_detail;
      this.modal_key++;
    },
    addHashtagIG: function () {
      this.modal = {};
      this.modal.title = "Tambah Hashtag Crawler Instagram";
      this.modal.subtitle =
        "Silahkan masukan hashtag tanpa menggunakan tanda '#'";
      this.modal.component = modal_add_hashtag;
      this.modal_data[0] = this.project_detail;
      this.modal_key++;
    },
    showFacebookDefault: function () {
      this.modal = {};
      this.modal.title = "Daftar Halaman Facebook";
      this.modal.subtitle =
        "Berikut ini adalah daftar halaman facebook yang otomatis dikumpulkan datanya";
      this.modal.component = facebook_page;
      this.modal_key++;
    },
    getFB: function () {
      let api = process.env.VUE_APP_API_URL + "fb-page/" + this.id_project;
      this.$http
        .get(api)
        .then((response) => {
          this.table_fb.clear().draw();
          if (response.status == 200) {
            this.data_fb = response.data; // Data existed
            let counter = 1;
            let btn;
            for (let index in this.data_fb) {
              btn =
                '<button class="btn btn-sm btn-danger del"><i class="bi bi-trash"></i></button>';
              this.table_fb.row
                .add([counter, this.data_fb[index].name, btn])
                .node().id = this.data_fb[index].id_page;
              this.table_fb.draw(false);
              counter++;
            }
          } else {
            this.result = [];
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    getHashtag: function () {
      let api = process.env.VUE_APP_API_URL + "ig-hashtags/" + this.id_project;
      this.$http
        .get(api)
        .then((response) => {
          this.table_hashtag.clear().draw();
          if (response.status == 200) {
            this.data_hashtag = response.data; // Data existed
            let counter = 1;
            let btn;
            for (let index in this.data_hashtag) {
              btn =
                '<button class="btn btn-sm btn-danger del"><i class="bi bi-trash"></i></button>';
              this.table_hashtag.row
                .add([counter, "#" + this.data_hashtag[index], btn])
                .node().id = index;
              this.table_hashtag.draw(false);
              counter++;
            }
          } else {
            this.result = [];
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    deleteHashtag: function (hashtag) {
      let self = this;
      swal({
        title: "Apakah anda yakin?",
        text: "Anda akan menghapus keyword #" + hashtag,
        icon: "warning",
        buttons: ["Tidak", "Ya"],
        dangerMode: true,
      }).then((yess) => {
        if (yess) {
          let params = {
            _id: this.id_project, //id_project
            hashtag: hashtag,
          };
          let api = process.env.VUE_APP_API_URL + "hashtag-delete";
          this.$http
            .post(api, params)
            .then(function (response) {
              if (response.status == 200) {
                $("body")
                  .pgNotification({
                    style: "bar",
                    message:
                      '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Hashtag berhasil dihapus.',
                    position: "top-right",
                    timeout: 5000,
                    type: "success",
                  })
                  .show();
                self.getHashtag();
              }
            })
            .catch(function (error) {
              console.log(error);
              $("body")
                .pgNotification({
                  style: "bar",
                  message:
                    '<i class="bi bi-x-circle"></i> <b>Error!</b> Terjadi kesalahan saat menghapus Hashtag.',
                  position: "top-right",
                  timeout: 5000,
                  type: "danger",
                })
                .show();
            });
        }
      });
    },
    deleteFB: function (page_id) {
      let self = this;
      swal({
        title: "Apakah anda yakin?",
        text: "Anda akan menghapus halaman fabebook tersebut dari daftar halaman facebook yang diambil datanya.",
        icon: "warning",
        buttons: ["Tidak", "Ya"],
        dangerMode: true,
      }).then((yess) => {
        if (yess) {
          let params = {
            _id: this.id_project, //id_project
            page: parseInt(page_id),
          };
          let api = process.env.VUE_APP_API_URL + "fb-page-delete";
          this.$http
            .post(api, params)
            .then(function (response) {
              if (response.status == 200) {
                $("body")
                  .pgNotification({
                    style: "bar",
                    message:
                      '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Halaman Facebook berhasil dihapus.',
                    position: "top-right",
                    timeout: 5000,
                    type: "success",
                  })
                  .show();
                self.getFB();
              }
            })
            .catch(function (error) {
              console.log(error);
              $("body")
                .pgNotification({
                  style: "bar",
                  message:
                    '<i class="bi bi-x-circle"></i> <b>Error!</b> Terjadi kesalahan saat menghapus Halaman Facebook.',
                  position: "top-right",
                  timeout: 5000,
                  type: "danger",
                })
                .show();
            });
        }
      });
    },
    getIcon: function (index) {
      let icon = "";
      if (index == "facebook") {
        icon = "bi bi-facebook";
      } else {
        icon = "bi bi-twitter";
      }
      return icon;
    },
  },
  created: function () {
    this.getFB();
    this.getHashtag();
  },
  mounted: function () {
    let self = this;

    this.table_fb = $("#table_fp").DataTable();
    $("#table_fp tbody").on("click", ".del", function () {
      var tr = $(this).closest("tr");
      let id = $(tr).attr("id");
      self.deleteFB(id);
    });

    this.table_hashtag = $("#table_hi").DataTable();
    $("#table_hi tbody").on("click", ".del", function () {
      var tr = $(this).closest("tr");
      // let id = $(tr).attr('id');
      // self.deleteHashtag(id);
      var data = self.table_hashtag.row(tr).data();
      let hashtag_to_delete = data[1].replace("#", "");
      self.deleteHashtag(hashtag_to_delete);
    });
  },
};
</script>

<style scoped>
@import "/assets/plugins/bootstrap-social/bootstrap-social.css";
</style>